import React from "react";
import { Outlet } from "react-router-dom";

const TimesheetOutlet = () => {
    return (
        <div className="dtr">
            <Outlet />
        </div>
    )
}

export default TimesheetOutlet;